<template>
  <div>
    <!-- 此组件无视觉输出，只负责逻辑处理 -->
  </div>
</template>
<script setup>
  import {onMounted, onUnmounted, ref} from 'vue';
  import Auth from "@/api/auth";
  import router from "@/router";

  const route = ref(router.currentRoute.value);
  const layout = ref({
    layoutType: 'vertical', // 'vertical', 'horizontal',
    mode: 'light',  // 'light', 'dark',
    sidebarSize: 'lg',  // 'lg', 'sm',
    sidebarColor: 'dark', // 'light', 'dark', 'gradient', 'gradient-2', 'gradient-3', 'gradient-4',
    sidebarImage: 'img-2',  // 'none', 'img-1', 'img-2', 'img-3', 'img-4',
    preloader: 'enable',  // 'enable', 'disable',
  })
  const logoutTimer = ref();
  // 设置登出时间，例如15分钟无操作自动登出
  const TIMEOUT = ref(1000 * 60 * 30); // 15 minutes

  // 重置定时器
  const resetTimer = () => {
    clearTimeout(logoutTimer.value);
    logoutTimer.value = setTimeout(() => {
      performLogout();
    }, TIMEOUT.value);
  };

  // 执行登出操作
  const performLogout = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if(user) {
      Auth.verificationToken(user.token).then(result => {
        if(result.code === 200) {
          TIMEOUT.value = Math.round(Number(result.data));
          resetTimer();
        }
        if (result.msg === '401') {
          logout();
        }
      }).catch(err => {
        if (err.msg === '401') {
          logout();
        }
      })
    }
  };

  function logout() {
    // 清除登录状态，如清除token、更新store等
    localStorage.clear()
    const layout = {
      layoutType: 'vertical', // 'vertical', 'horizontal',
      mode: 'light',  // 'light', 'dark',
      sidebarSize: 'lg',  // 'lg', 'sm',
      sidebarColor: 'dark', // 'light', 'dark', 'gradient', 'gradient-2', 'gradient-3', 'gradient-4',
      sidebarImage: 'img-2',  // 'none', 'img-1', 'img-2', 'img-3', 'img-4',
      preloader: 'enable',  // 'enable', 'disable',
    }
    localStorage.setItem('layout', JSON.stringify(layout));
    localStorage.setItem('language', 'en-US');
    clearTimeout(logoutTimer.value);
    removeEventListeners();
    // setTimeout(() => router.push('/login'), 500);  // 重定向到登录页
    setTimeout(() => location.reload() ,500)
  }

  // 监听活动事件
  const events = ['click', 'mousemove', 'keypress'];
  const setupEventListeners = () => {
    events.forEach(event => {
      TIMEOUT.value = 1000 * 60 * 30;
      window.localStorage.setItem('lastTime', String(new Date().getTime()));
      window.addEventListener(event, resetTimer, true);
    });
  };

  const removeEventListeners = () => {
    events.forEach(event => {
      TIMEOUT.value = 1000 * 60 * 30;
      window.removeEventListener(event, resetTimer, true);
    });
  };

  function checkUserAndReload() {
    if (!localStorage.getItem('user') && route.value.path !== '/login' && route.value.name !== undefined) {
      location.reload()
    }
  }

  onMounted(() => {
    resetTimer();
    setupEventListeners();
    if(!localStorage.getItem('layout')) {
      localStorage.setItem('layout', JSON.stringify(layout.value))
    }
    // 每1分钟执行一次 checkUserAndReload 函数
    setInterval(checkUserAndReload, 1000 * 60);
    // 初始检查一次
    checkUserAndReload();
  });

  onUnmounted(() => {
    clearTimeout(logoutTimer.value);
    removeEventListeners();
  });
</script>
